import styled from 'styled-components';

export const Content = styled.div`
  text-align: center;
  justify-content: center;
  min-height: 80%;
`;
